"use client";
import { usePostHog } from "posthog-js/react";

import { PitchKnob } from "@/components/pitchCorrection/PitchKnob";
import { PitchSelectMenu } from "@/components/pitchCorrection/PitchSelectMenu";
import { VibratoKnob } from "@/components/pitchCorrection/VibratoKnob";
import { useAudioInput } from "@/lib/zustand/useAudioInput";
import { isSelectedFile } from "@/utils/selectedFileCover/is/isSelectedFile";

export function QuickTuneKnobs({
  conversionNamespace,
  namespace,
  onEnd,
  noKeyIsAnOption,
}: {
  conversionNamespace: string;
  namespace: string;
  onEnd: () => void;
  noKeyIsAnOption: boolean;
}) {
  const posthog = usePostHog();

  const useConversionInput = useAudioInput((state) =>
    state.getNamedStore(conversionNamespace)
  );
  const selectedFileCover = useConversionInput(
    (state) => state.selectedFileCover
  );
  const shouldDisableRotaryKnobs = !(
    selectedFileCover !== null &&
    selectedFileCover !== undefined &&
    isSelectedFile(selectedFileCover)
  );

  return (
    <div className="flex items-center gap-4">
      <div className="flex flex-col items-center">
        <VibratoKnob
          namespace={namespace}
          keyNamespace={namespace}
          disabled={shouldDisableRotaryKnobs}
          inactiveCondition={false}
          onEnd={() => {
            onEnd();
            posthog?.capture("quicktuningUsed");
          }}
        />
        <span className="select-none text-xs">De-vibrato</span>
      </div>
      <div className="flex flex-col items-center">
        <PitchKnob
          namespace={namespace}
          keyNamespace={namespace}
          disabled={shouldDisableRotaryKnobs}
          inactiveCondition={false}
          onEnd={() => {
            onEnd();
            posthog?.capture("quicktuningUsed");
          }}
        />
        <span className="select-none text-xs">Pitch</span>
      </div>
      <PitchSelectMenu
        noKeyIsAnOption={noKeyIsAnOption}
        namespace={namespace}
      />
    </div>
  );
}
